import React from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./navbar";
import Fallbacksuspense from "../components/Fallbacksuspense";

function Layout() {
  return (
    <div>
      <React.Suspense fallback={<Fallbacksuspense />}>
        <Header />
        <Outlet />
        <Footer />
      </React.Suspense>
    </div>
  );
}

export default Layout;
